<div>
  <h1 class="text-title-4 mb-8">{{ 'rogers.otpDeviceList.header' | translate }}</h1>

  @if (error === 'tooManyAttemptsOrExpired') {
    <div class="mb-16">
      <ds-alert
        variant="error"
        [closeLabel]="'rogers.login.popOverClose' | translate"
        (closeClick)="resetErrorMessage()"
        role="alert">
        <div class="d-flex flex-column flex-md-row">
          <div class="flex-grow-1 d-flex">
            <ds-icon
              class="mr-8"
              name="error-outlined"
              color="error"
              [ariaHidden]="false"
              [attr.title]="'rogers.login.accessibility.error' | translate"
              caption="Attention">
            </ds-icon>
            <div>
              <p damTranslationWithRouting
                class="text-body mb-0 mw-content">
                {{ 'rogers.verifySms.error.tooManyAttemptsOrExpired' | translate }}
              </p>
            </div>
          </div>
        </div>
      </ds-alert>
    </div>
  }

  <p class="mb-24 text-body-lg">{{ 'rogers.otpDeviceList.description' | translate }}</p>
  <ng-container ssTrackEvent [event]="track.otpMethodSelection"></ng-container>
  @if (targetsCount === 1 && !hideCtn && brand !== 'media') {
    <div>
      <button
        ds-button [disabled]="true"
        role="button"
        class="w-100 mb-16"
        title="{{ 'rogers.otpDeviceList.accessibility.sms' | translate }}"
        type="button">
        <span> {{ 'rogers.otpDeviceList.channels.sms' | translate }} : ***.***.****</span>
      </button>
    </div>
  }

  @for (target of formattedTargets; track target; let i = $index) {
    <div>
      @if (target.targetDescription === 'null') {
        <div>
          <button
            ds-button [disabled]="true"
            role="button"
            class="w-100 mb-16"
            (click)="chooseOTPTarget(target.order)"
            title="{{ target.title | translate }}"
            type="button">
            <span> {{ target.text | translate }} : ***.***.****</span>
          </button>
        </div>
      } @else {
        <button
          ds-button
          role="button"
          class="w-100 mb-16"
          (click)="chooseOTPTarget(target.order)"
          title="{{ target.title | translate }}"
          type="button">
          <span> {{ target.text | translate }} : {{target.targetDescription}}</span>
        </button>
      }
    </div>
  }

  @if (targetsCount === 1 && !hideCtn && brand === 'media') {
    <div>
      <button
        ds-button [disabled]="true"
        role="button"
        class="w-100 mb-16"
        title="{{ 'rogers.otpDeviceList.accessibility.sms' | translate }}"
        type="button">
        <span> {{ 'rogers.otpDeviceList.channels.sms' | translate }} : ***.***.****</span>
      </button>
    </div>
  }

  @if (!hideEmail) {
    <div>
      <button
        ds-button [disabled]="true"
        role="button"
        class="w-100 mb-16"
        title="{{ 'rogers.otpDeviceList.accessibility.email' | translate }}"
        type="button">
        <span> {{ 'rogers.otpDeviceList.channels.email' | translate }} : **********</span>
      </button>
    </div>
  }
</div>
